import { CashTerminalList, CashTerminalResponse, DocumentPaymentList, PaymentMethodList, PaymentMethodResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/payments` — as formas de pagamento e o registro append-only do que
 * entrou e do que voltou.
 *
 * "Remover" na tela é arquivar no servidor: o papel da aplicação não tem
 * DELETE em `payment_method` (Master Specification seção 30).
 */
// Every amount crossing this boundary is a string, for the reason ADR-0016
// gives. `formatMoney` turns one into `R$ 19,90` for a reader;
// `parseHumanAmount` turns what somebody typed back into an exact value. A
// JSON number would have lost the argument before either ran.
/**
 * The tills of a branch.
 *
 * Read on `pos.operate` so an operator can choose one; written on
 * `pos.supervise`, because which drawers a shop has is not an operator's call.
 */
export const fetchCashTerminals = async (query = {}, signal) => {
    const params = new URLSearchParams();
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return CashTerminalList.parse(await request(`/api/v1/cash/terminals${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
export const createCashTerminal = async (input) => CashTerminalResponse.parse(await request('/api/v1/cash/terminals', { method: 'POST', body: input }));
export const updateCashTerminal = async (id, input) => CashTerminalResponse.parse(await request(`/api/v1/cash/terminals/${id}`, {
    method: 'PATCH',
    body: input,
}));
export const fetchPaymentMethods = async (query = {}, signal) => {
    const params = new URLSearchParams();
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return PaymentMethodList.parse(await request(`/api/v1/payments/methods${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
export const createPaymentMethod = async (input) => PaymentMethodResponse.parse(await request('/api/v1/payments/methods', { method: 'POST', body: input }));
export const updatePaymentMethod = async (id, input) => PaymentMethodResponse.parse(await request(`/api/v1/payments/methods/${id}`, {
    method: 'PATCH',
    body: input,
}));
/**
 * "Remove" on the screen, archive on the server.
 *
 * A POST rather than a DELETE, because the application role holds no DELETE on
 * `payment_method` (Master Specification section 30) and a verb promising
 * deletion would describe something the product deliberately cannot do.
 */
export const archivePaymentMethod = async (id, version) => PaymentMethodResponse.parse(await request(`/api/v1/payments/methods/${id}/archive`, {
    method: 'POST',
    body: { version },
}));
export const reorderPaymentMethods = async (methodIds) => PaymentMethodList.parse(await request('/api/v1/payments/methods/order', {
    method: 'POST',
    body: { methodIds },
}));
export const installDefaultPaymentMethods = async () => PaymentMethodList.parse(await request('/api/v1/payments/methods/defaults', { method: 'POST' }));
/**
 * O que foi pago num documento, e o troco (F150).
 *
 * A reimpressão da nota precisa disto: `SalesDocumentDetail` não carrega
 * pagamento nenhum, e um recibo sem a forma de pagamento e sem o troco não é a
 * nota que o cliente levou.
 *
 * `total` vai junto porque este módulo não sabe o que é uma venda (ADR-0018) —
 * é o chamador que diz quanto era devido, e é dele que sai o troco.
 */
export const fetchDocumentPayments = async (query, signal) => {
    const params = new URLSearchParams({ documentType: query.documentType });
    if (query.documentId !== undefined) {
        params.set('documentId', query.documentId);
    }
    if (query.total !== undefined)
        params.set('total', query.total);
    return DocumentPaymentList.parse(await request(`/api/v1/payments/?${params.toString()}`, { signal }));
};
//# sourceMappingURL=payments.js.map